import { ApiEnvironment } from '../../models/api-environment';

export class CrashDumpEnvironment extends ApiEnvironment {
  get retrieveCrashLogsUrl() {
    return `${this.baseUrl}/crash-dump-api/v1/retrievecrashlogs`;
  }

  override resolve(environment: unknown) {
    return environment instanceof CrashDumpEnvironment ? environment : this;
  }
}

export const crashDumpEnvironment = new CrashDumpEnvironment();
